import { render, staticRenderFns } from "./MsBrowsePane.vue?vue&type=template&id=4bb1be48&scoped=true"
import script from "./MsBrowsePane.vue?vue&type=script&lang=js"
export * from "./MsBrowsePane.vue?vue&type=script&lang=js"
import style0 from "./MsBrowsePane.vue?vue&type=style&index=0&id=4bb1be48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb1be48",
  null
  
)

export default component.exports